/**
 * @description 向vue实例注入公共属性或方法
 */
export default {
  data () {
    return {
      isClickLocked: false,
    }
  },
  methods: {
    /**
     * @description 锁 防止重复点击 ; weex-web单击事件会响应三次，很奇怪，加锁防止重复提交
     */
    checkLock () {
      if (this.isClickLocked) return true;
      this.isClickLocked = true;
      setTimeout(() => {
        this.isClickLocked = false;
      }, 300);
      return false;
    },
  }
}
